<template>
    <v-container fluid class="py-0">
        <v-dialog v-model="dialog" max-width="300" content-class="rounded-medium">
            <v-form ref="form" :disabled="submitLoading" @submit.prevent="submit">
                <v-card>
                    <v-card-title>
                        {{!itemId ? $t('add') : $t('edit')}} {{$t('InvoicesTypes.type')}}
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                            v-model="name"
                            :label="$t('inputs.type')"
                        	outlined
                        	dense
                        	hide-details
                            :rules="[rules.required]"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="success" type="submit" :loading="submitLoading">{{$t('save')}}</v-btn>
                        <v-btn @click="dialog = false">{{$t('cancel')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <!-- title & buttons -->
		<v-row class="ma-0 align-center">
			<v-col cols="auto"  align="center" class="d-flex justify-start">
				<slot name="breadcrumbs" :item="true"></slot>
			</v-col>

            <v-spacer/>

			<v-col cols="auto">
				<v-btn color="success white--text" class="mx-2" @click="dialog = true">
					<v-icon> mdi-plus-circle-outline </v-icon>
					{{$t('add')}} {{$t('InvoicesTypes.type')}}
				</v-btn>
			</v-col>
		</v-row>

        <bee-handy-table
        	:headers="headers"
            :items="items"
            :items-per-page="-1"
            :loading="loading"
            :data-table-props="{ disableSort: true }"
            dense
            hide-default-footer
        >
            <template v-slot:item.actions="{ item }">
                <v-btn
                    depressed
                    height="34"
                    width="38"
                    min-width="38"
                    color="edit-color white--text"
                    class="px-1"
                    @click="itemId = item.id; dialog = true;"
                >
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
        </bee-handy-table>
    </v-container>
</template>

<script>
import validation from '@/validation'
import eventBus from '@/event-bus'
import { useInvoicesTypes } from '@/configs/global'
export default {
    name: 'InvoicesTypes',

    data() {
        return {
            loading: false,
            submitLoading: false,
            itemId: null,

            dialog: false,
            rules: validation.rules,

            // submit data
            name: null
        }
    },

    watch: {
        dialog(val) {
            if (val) {
                if (this.itemId) {
                    // this.name = this.getInvoiceTypeById(this.itemId).name
                    this.name = this.items.find(c => c.id === this.itemId).name
                }
            } else {
                this.$refs.form.reset();
                this.itemId = null;
            }
        }
    },

    computed: {
        headers() {
            return [
                { text: this.$t('headers.type'), name: 'type', value: 'name' },
                { text: '', name: 'actions', value: 'actions', width: 40 },
            ];
        },

        items() {
            const items = [
                { id: 1, name: 'جملة' },
                { id: 2, name: 'نص جملة' },
                { id: 3, name: 'مفرق' },
            ];
            return items;
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.submitLoading = true;
                const actionName = !this.itemId ? 'create' : 'update';
                this.$store.dispatch(`invoicesTypes/${actionName}`, {
                    id: this.itemId,
                    name: this.name,
                }).then(() => {
                    eventBus.$emit(
                        'notification',
                        !this.itemId
                            ? this.$t('messapges.adding-completed-successfully')
                            : this.$t('messapges.edit-completed-successfully')
                    );
                }).finally(() => {
                    this.submitLoading = true;
                })
            }
        }
    },

    beforeRouteEnter(to, from, next) {
        if (useInvoicesTypes) next(true);
        else next({ name: 'home' })
    }
}
</script>

<style>

</style>